import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  
  connect() {
    if (this.data.get('trainingType') == 'training-event') {
      $('html,body').animate({scrollTop: $("#myTab").offset().top}, 400);
    }
  }
}
